// extracted by mini-css-extract-plugin
export default {"optionLabel":"optionLabel__7DPdz","optionWeb":"optionWeb__3RjIq","checked":"checked__V-gBd","pulse-radio":"pulse-radio__D0Tmm","otherInput":"otherInput__wYw2-"};